import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import notify from 'devextreme/ui/notify';
import * as Highcharts from 'highcharts';
import { DeviceDetectorService } from 'ngx-device-detector';
import { concat } from 'rxjs/observable/concat';
import { zip } from 'rxjs/observable/zip';
import { map } from 'rxjs/operator/map';
import { mergeMap } from 'rxjs/operator/mergeMap';
import { ReportService } from '../report.service';

@Component({
  selector: 'externo-charts',
  templateUrl: './externo-charts.component.html',
  styleUrls: ['./externo-charts.component.css']
})
export class ExternoChartsComponent implements OnInit {

  chartOptions64: any;
  chartOptions60: any;
  detalleTablaContratacion: any[] = [];
  detalleTablaContratacionheaders: any[] = [];
  popupVisible: boolean;
  selectedIndex: any;
  isMobile: any;
  isTablet: any;
  chartOptions11: any;
  chartOptions1: any;
  chartOptions2: any;
  width: any;
  pdfSrc: SafeUrl ;
  Highcharts = Highcharts;
  dataTable: any = [];
  headers: any = [];
  tabs: any = [
    {
      text: 'Operaciones Contratadas'
    }, {
      text: 'Contratación de deuda por organismo financiador'
    }, {
      text: 'Desembolsos de Créditos'
    }
  ];
  constructor(private service: ReportService, private deviceService: DeviceDetectorService, public sanitizer: DomSanitizer,) { }

  ngOnInit() {

    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    if(this.isMobile || this.isTablet) {
      this.width = window.innerWidth - 80 + 'px';
      //this.widthTable = window.innerWidth - 80 + 'px';fevents
      //this.width1 = window.innerWidth - 50;
    } else {
      var d = document.getElementsByClassName('container');
      let e: Element = d.item(3);
      this.width = e['offsetWidth'] - 80 + 'px';
      //this.width1 = window.innerWidth - 50;
      //this.widthTable = this.width;
    }
    this.selectedIndex = 0;
    this.selectedTab(this.selectedIndex);
    
  }
  evento(e, title?) {
      console.log('EVENT',e);
      this.getData(e.point.url);
      let dt = e.point.url.split('=');
      e.point['_type'] = 'chart';
      if(dt[dt.length - 1]=='PDF') {
        try{
          if(this.isMobile) {
            window.location.href = e.point.url;
          } else {
            this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(e.point.url);
            //this.popupVisible = true;
          }
        }catch(e) {
          notify('El documento no existe', 'error', 2000);
        }
      }
      
      
    //}
  }
  getData(url) {
    this.service.getDataByUrl(url).subscribe(response => {
      this.popupVisible = true;
      console.log(response);
      this.dataTable = response;
      if(this.dataTable.length>0) {
        this.headers = Object.keys(this.dataTable[0]);
        delete this.headers['id'];
        console.log(this.headers);
      }
      
    }, err => {
      console.log(err);
      notify('Error', 'error', 2000);
    });

  }
  selectTab(e) {

    this.selectedIndex = e.itemIndex;
    this.selectedTab(this.selectedIndex);  
    
  }
  selectedTab(index) {
    switch(index) {
      case 0:
        zip(this.service.getCharts(59), this.service.getCharts(60)).subscribe(response => {
          this.chartOptions11 = response[0];
          this.chartOptions11.plotOptions.series.point.events.click = (e) => {this.evento(e, this.chartOptions11['title']);};
          this.chartOptions60 = response[1];
          this.chartOptions60.plotOptions.series.point.events.click = (e) => {this.evento(e, this.chartOptions60['title']);};
        });
        break;
      case 1:
          zip(this.service.getDetalleTablaContratacion(), this.service.getCharts(64)).subscribe(response => {
            this.detalleTablaContratacion = response[0];
            if(this.detalleTablaContratacion.length > 0) {
              this.detalleTablaContratacionheaders = Object.keys(this.detalleTablaContratacion[0]);
            }
            this.chartOptions64 = response[1];
            this.chartOptions64.plotOptions.series.point.events.click = (e) => {this.evento(e, this.chartOptions64['title']);};
          });
        break;
      case 2:
        zip(this.service.getCharts(61), this.service.getCharts(63)).subscribe(response => {
          this.chartOptions1 = response[0];
          this.chartOptions1.plotOptions.series.point.events.click = (e) => {this.evento(e, this.chartOptions1['title']);};
          this.chartOptions2 = response[1];
          this.chartOptions2.plotOptions.series.point.events.click = (e) => {this.evento(e, this.chartOptions2['title']);};
        });
        
        break;  
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/report/externo-charts/externo-charts.component.ts